export default __webpack_public_path__ + "static/media/sec1.210e248d.png";